<template lang="html">
  <div class="add-map-dialog ai-dialog">
    <div class="map-dialog-content">
      <header>
        <slot name="header"></slot>
      </header>
      <slot name="content"></slot>
      <div class="map-dialog-content-button">
        <p @click="newMap" :class="{'submitDisabled': buttonDisabled, 'submit': !buttonDisabled, 'deleteMap': deleteButton}">确认</p>
        <p @click="closeDialog">取消</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      buttonDisabled: true,
      deleteButton: false
    };
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    newMap() {
      this.$emit("newMap");
    }
  }
};
</script>

<style scoped lang="scss">
.add-map-dialog {
  background: rgba(0, 0, 0, 0.5);
  pointer-events: auto;
  .map-dialog-content {
    width: 280px;
    height: 160px;
    padding: 40px;
    background: #393939;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    z-index: 1001;
    header {
      font-size: 20px;
      color: #ffffff;
    }
    .message {
      margin-bottom: 34px;
      font-size: 20px;
      color: #ffffff;
    }
    .message-icon {
      width: 28px;
      height: 28px;
      margin-left: calc(50% - 14px);
      margin-bottom: 12px;
    }
    .delete-msg {
      text-align: center;
    }
    input {
      background: #212121;
      border: 1px solid #ffffff;
      border-radius: 4px;
      width: 275px;
      height: 36px;
      color: #fff;
      font-size: 16px;
      margin: 12px 0 52px 0;
      padding: 0 4px;
    }
    .map-dialog-content-button {
      display: flex;
      justify-content: space-between;
      .submitDisabled {
        opacity: 0.2;
        color: #08ce82;
        border: 1px solid #08ce82;
      }
      p {
        width: 123px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        border-radius: 4px;
        border: 1px solid #adadad;
        color: #adadad;
        margin: 0;
        cursor: pointer;
      }
      .submit {
        color: #08ce82;
        border: 1px solid #08ce82;
      }
      .deleteMap {
        color: #ff3b30;
        border: 1px solid #ff3b30;
      }
    }
  }
}
</style>
